module.exports = __webpack_public_path__ + "static/media/AZN LOGO .1cf45755.jpg";